import {
  IMusicProductDigitalSettlementInfoForm,
  IMusicProductDigitalSettlementInfoPerTrackContractForm,
} from 'services/music-product-digital/types/form';
import {
  IMusicProductDigitalSettlementInfoPerTrackContractResponse,
  IMusicProductDigitalSettlementInfoResponse,
} from 'services/music-product-digital/types/query';
import { formatDateToInput } from 'utils/global/date.utils';

export const settlementInfoQueryToForm = (
  settlementResponse: IMusicProductDigitalSettlementInfoResponse | null
): IMusicProductDigitalSettlementInfoForm => ({
  perTrackSettlement: settlementResponse?.perTrackSettlement ?? false,
  contracts:
    settlementResponse?.contracts.map(c => ({
      ...c,
      startDate: formatDateToInput(c.startDate),
      endDate: c.endDate ? formatDateToInput(c.endDate) : null,
    })) ?? [],
  perTrackContracts: groupContractsByTrack(
    settlementResponse?.perTrackContracts ?? []
  ),
});

export const groupContractsByTrack = (
  data: IMusicProductDigitalSettlementInfoPerTrackContractResponse[]
): IMusicProductDigitalSettlementInfoPerTrackContractForm[] => {
  const groupedMap = new Map<string, any>();

  data.forEach(contract => {
    const { trackId, title, ...contractDetails } = {
      ...contract,
      startDate: formatDateToInput(contract.startDate),
      endDate: contract.endDate ? formatDateToInput(contract.endDate) : null,
    };

    if (!groupedMap.has(trackId)) {
      groupedMap.set(trackId, {
        title: title,
        trackId,
        contracts: [],
      });
    }

    groupedMap.get(trackId).contracts.push(contractDetails);
  });

  return Array.from(groupedMap.values());
};
